// extracted by mini-css-extract-plugin
module.exports = {"spinner-overlay":"spinner-module--spinner-overlay--HoYDf","spinner-container":"spinner-module--spinner-container--30PRj","spin":"spinner-module--spin--Zf47Y"};